<section class="page-stack">
  <div class="section-header">
    <div>
      <p class="eyebrow mb-1">Treasury</p>
      <h2>Admin Fund Pool</h2>
    </div>
  </div>

  @if (notice) {
    <div class="alert alert-info">{{ notice }}</div>
  }
  @if (error) {
    <div class="alert alert-danger">{{ error }}</div>
  }

  <div class="dashboard-grid">
    <div class="metric-card cyan">
      <span>Fund Pool Balance</span>
      <strong>{{ money(summary?.pool?.balance_cents) }}</strong>
      <small>{{ summary?.pool?.name || 'Global admin fund pool' }}</small>
    </div>
    <div class="metric-card green">
      <span>Status</span>
      <strong>{{ summary?.pool?.status || 'active' }}</strong>
      <small>Fallback source for portfolio shortfalls</small>
    </div>
  </div>

  <div class="panel p-3">
    <form class="row g-3 align-items-end" (ngSubmit)="submit()">
      <div class="col-md-2">
        <label class="form-label">Action</label>
        <select class="form-select" name="direction" [(ngModel)]="direction">
          <option value="credit">Credit</option>
          <option value="debit">Debit</option>
        </select>
      </div>
      <div class="col-md-3">
        <label class="form-label">Amount</label>
        <input class="form-control" type="number" name="amount" [(ngModel)]="amount" min="0">
      </div>
      <div class="col-md-5">
        <label class="form-label">Narration</label>
        <input class="form-control" name="narration" [(ngModel)]="narration" placeholder="Reason for this treasury adjustment">
      </div>
      <div class="col-md-2">
        <button class="btn btn-accent w-100" [disabled]="saving || amount <= 0">
          {{ saving ? 'Saving...' : 'Submit' }}
        </button>
      </div>
    </form>
  </div>

  <div class="panel">
    <div class="table-responsive">
      <table class="table table-dark table-hover align-middle mb-0">
        <thead>
          <tr>
            <th>Date</th>
            <th>Type</th>
            <th>Amount</th>
            <th>Balance After</th>
            <th>Narration</th>
            <th>Loan</th>
          </tr>
        </thead>
        <tbody>
          @if (loading) {
            <tr><td colspan="6" class="text-center py-4">Loading fund pool...</td></tr>
          } @else if (!summary?.transactions?.length) {
            <tr><td colspan="6" class="text-center py-4 text-muted-soft">No fund pool transactions yet.</td></tr>
          } @else {
            @for (tx of summary?.transactions; track tx.id) {
              <tr>
                <td>{{ tx.created_at | date:'medium' }}</td>
                <td>{{ tx.type }}</td>
                <td [class.text-success]="tx.direction === 'credit'" [class.text-danger]="tx.direction === 'debit'">{{ signedAmount(tx) }}</td>
                <td>{{ money(tx.balance_after_cents) }}</td>
                <td>{{ tx.narration }}</td>
                <td>{{ tx.related_loan_id || '-' }}</td>
              </tr>
            }
          }
        </tbody>
      </table>
    </div>
  </div>
</section>
